const baseUrl = "http://39.105.12.64:92";

export default {
  homeUrl: baseUrl + "/home",
  recipeUrl: baseUrl + "/recipe/list",
  xiangqingUrl: baseUrl + "/recipe/detail",
  fenleiUrl: baseUrl + "/recipe/catalogs",
  //cookId 必要参数
};
